import React from "react";
import PlayerEligibility from "../components/player-eligibility/PlayerEligibility";

const PlayerEligibilityContainer = () => {
  return <PlayerEligibility />;
};

export default PlayerEligibilityContainer;
